import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IdOutskirtBuildings } from "../../../constants/IdOutskirtBuildings";
import { actionAddPelletsInScreenCenterAnimation } from "../../animation/actionPelletAnimations";
import { getResourceIconInfo } from "../../generic/icon/getResourceIconInfo";
import { actionInventoryInfoAddResource } from "../../info/inventory/actionInventoryInfo";
import { actionModalCloseAll } from "../../modals/actionModal";
import { actionThemedEventRewardCollected, TypeActionThemedEvent, } from "../actionThemedEvent";
export var epicThemedEventCollectReward = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionThemedEvent.CollectReward), switchMap(function (action) {
        var rewardItem = {
            amount: action.rewardAmount,
            typeId: action.rewardId,
        };
        return from([
            actionAddPelletsInScreenCenterAnimation(IdOutskirtBuildings.ThemedEvent, [
                {
                    amount: action.rewardAmount.toNumber(),
                    icon: getResourceIconInfo(rewardItem).icon,
                },
            ]),
            actionInventoryInfoAddResource([rewardItem]),
            actionModalCloseAll(),
            actionThemedEventRewardCollected(),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/epics/epicThemedEventCollectReward.ts
// module id = 2422
// module chunks = 3